export default __webpack_public_path__ + "77a030e88d96f6fc6230f39b7e0892e2.png";